/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * Audius V1 API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './User';

/**
 * 
 * @export
 * @interface RelatedArtistResponse
 */
export interface RelatedArtistResponse {
    /**
     * 
     * @type {Array<User>}
     * @memberof RelatedArtistResponse
     */
    data?: Array<User>;
}

/**
 * Check if a given object implements the RelatedArtistResponse interface.
 */
export function instanceOfRelatedArtistResponse(value: object): value is RelatedArtistResponse {
    let isInstance = true;

    return isInstance;
}

export function RelatedArtistResponseFromJSON(json: any): RelatedArtistResponse {
    return RelatedArtistResponseFromJSONTyped(json, false);
}

export function RelatedArtistResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RelatedArtistResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(UserFromJSON)),
    };
}

export function RelatedArtistResponseToJSON(value?: RelatedArtistResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(UserToJSON)),
    };
}

